<template>
  <a
    v-if="link"
    :href="link"
    target="_blank"
    class="modal-menu__item"
  >
    <slot />

    <slot
      name="icon"
      :iconClass="'modal-menu__item-icon'"
    />
  </a>

  <component
    :is="to ? 'router-link' : 'div'"
    v-else
    :to="to"
    class="modal-menu__item"
    :class="{
      'justify-left': left,
      'justify-right': right,
      disabled,
    }"
  >
    <slot />

    <slot
      name="icon"
      :iconClass="'modal-menu__item-icon'"
    />
  </component>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router';

defineProps<{
  disabled?: boolean;
  left?: boolean;
  right?: boolean;
  link?: string;
  to?: RouteLocationRaw;
}>();

</script>

<style lang="scss">
@import "@/assets/style/include";

.modal-menu__item {
  display: flex;
  background-color: $bgLight1;
  padding: 18px 12px;
  transition: box-shadow $transition-speed, background $transition-speed;
  user-select: none;
  cursor: pointer;

  @include hover-focus() {
    color: $color-white;
    background-color: $colorBlueHover;
  }

  &:active {
    background-color: $colorBlueHover;
  }

  &.disabled {
    pointer-events: none;
  }

  &.justify-left {
    justify-content: left;
  }

  &.justify-right {
    justify-content: right;
  }

  &.header-profile__link {
    color: $colorText1;
  }
}

.modal-menu__item-icon {
  width: 1rem;
  height: 1rem;
  margin-left: 10px;
}
</style>
